import { BrowserModule } from "@angular/platform-browser";
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, APP_INITIALIZER } from "@angular/core";
import {
  HttpClientModule,
  provideHttpClient,
  withInterceptors,
} from "@angular/common/http";
import { AppComponent } from "./app.component";
import { DiagramComponent } from "./components/diagram/diagram.component";
import { DiagramViewerComponent } from "./components/diagram-viewer/diagram-viewer.component";
import { ModalModule } from "ngx-bootstrap/modal";
import { DataTablesModule } from "angular-datatables";
import { BodyComponent } from "./components/body/body.component";
import { SidenavComponent } from "./components/sidenav/sidenav.component";
import { SublevelMenuComponent } from "./components/sidenav/sublevel-menu.component";
import { AppRoutingModule } from "./app-routing.module";
import { LoginComponent } from "./components/login/login.component";
import { ModalNotifyComponent } from "./components/modal-notify/modal-notify.component";
import { LayoutComponent } from "./components/layout/layout.component";
import { FormsModule, ReactiveFormsModule  } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { ShowDiagramComponent } from "./components/show-diagram/show-diagram.component";
import { UserNavComponent } from "./components/user-nav/user-nav.component";
import { FormComponent } from "./components/form/form.component";
import { DatatableHistorialComponent } from "./components/datatable-historial/datatable-historial.component";
import { OptionsDiagramComponent } from "./components/optionsdiagram/optionsdiagram.component";
import { UsuariosComponent } from "./components/usuarios/usuarios.component";
import { OldDataTableComponent } from "./components/old-data-table/old-data-table.component";
import { customInterceptor } from "./services/custom.interceptor";
import { GrupoComponent } from "./components/grupo/grupo.component";
import { DatatableProcesosComponent } from "./components/datatable-procesos/datatable-procesos.component";
import { RolComponent } from "./components/rol/rol.component";
import { DatatableFormulariosComponent } from "./components/datatable-formularios/datatable-formularios.component";

import { FormEditComponent } from "./components/form-edit/form-edit.component";
import { IniciarProcesoComponent } from "./components/iniciar-proceso/iniciar-proceso.component";
import { TareasComponent } from "./components/tareas/tareas.component";
import { LogoutComponent } from "./components/logout/logout.component";
import { UsernavLogComponent } from "./components/usernav-log/usernav-log.component";
import { AccesoComponent } from "./components/acceso/acceso.component";
import { NotifyDataComponent } from "./components/notify-data/notify-data.component";
import { FormRedirectComponent } from "./components/form-redirect/form-redirect.component";
import { OtpEnlaceComponent } from "./components/otp-enlace/otp-enlace.component";


import { TextBoxComponent } from "./components/controls/text-box/text-box.component";
import { TextAreaComponent } from "./components/controls/text-area/text-area.component";
import { ComboBoxComponent } from "./components/controls/combo-box/combo-box.component";
import { CheckBoxComponent } from "./components/controls/check-box/check-box.component";
import { HtmlEditorComponent } from "./components/controls/html-editor/html-editor.component";
import { ButtonComponent } from "./components/controls/button/button.component";
import { FormButtonsComponent } from "./components/controls/form-buttons/form-buttons.component";
import { DataTableComponent } from "./components/controls/data-table/data-table.component";
import { DateRangeBoxComponent } from "./components/controls/date-range-box/date-range-box.component";
import { NgSelectModule } from '@ng-select/ng-select';
import { SupersetReportComponent } from './components/superset-report/superset-report.component';

import { AppData } from "./helpers/app-data";

import { LiveAnnouncer } from "@angular/cdk/a11y";
import { COMMA, ENTER } from "@angular/cdk/keycodes";
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  model,
  signal,
} from "@angular/core";
import {
  MatAutocompleteModule,
  MatAutocompleteSelectedEvent,
} from "@angular/material/autocomplete";
import { MatChipInputEvent, MatChipsModule } from "@angular/material/chips";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatDatepickerModule } from '@angular/material/datepicker';
import { AuditoriaProcesosComponent } from "./components/auditoria-procesos/auditoria-procesos.component";
import { RenderFormComponent } from "./components/render-form/render-form.component";
import { SkeletonFormComponent } from './components/skeleton-form/skeleton-form.component';
import { PermisosMenuComponent } from './components/permisos-menu/permisos-menu.component';
//import {NgxExtendedPdfViewerModule} from 'ngx-extended-pdf-viewer'
import { PreventOutsideClickDirective } from './directives/prevent-outside-click.directive';
import { GenericModalComponent } from "./components/generic-modal/generic-modal.component";
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { ProcessDashboardComponent } from './components/process-dashboard/process-dashboard.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { PlantillasComponent } from './components/plantillas/plantillas.component';
import { ConectoresComponent } from './components/conectores/conectores.component';
import { TipoConectorComponent } from './components/tipo-conector/tipo-conector.component';
import { DatatableBancoProcesosComponent } from './components/datatable-banco-procesos/datatable-banco-procesos.component';
import { ReporteriaAdminComponent } from './components/reporteria-admin/reporteria-admin.component';
import { ReporteriaVisorComponent } from './components/reporteria-visor/reporteria-visor.component';
import {
  MsalModule,
  MsalGuard,
  MsalInterceptor,
  MsalGuardConfiguration,
  MsalInterceptorConfiguration
} from '@azure/msal-angular';

import {
  IPublicClientApplication,
  PublicClientApplication,
  InteractionType
} from '@azure/msal-browser';

import { MsalConfigApp } from './services/msal-config.service';

declare let ConfigData:any;

// 1. Instancia de MSAL usando tu config anterior
export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    ...MsalConfigApp.loadConfig(),
    cache: {
      cacheLocation: 'sessionStorage', // <--- Cambia a sessionStorage
      storeAuthStateInCookie: false
    }
  });
}

// 2. Antes: consentScopes: ['user.read']
export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,      // o Popup si quieres
    authRequest: {
      scopes: [ConfigData.ScopeSSO]                         // <<-- equivale a consentScopes
    },
    loginFailedRoute: '/login-failed'
  };
}

// 3. Antes: protectedResourceMap: [['https://graph.microsoft.com/v1.0/me', ['user.read']]]
export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();

  protectedResourceMap.set(
    'https://graph.microsoft.com/v1.0/me',
    [ConfigData.ScopeSSO]
  );

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap
  };
}


@NgModule({
  declarations: [
    AppComponent,
    DiagramComponent,
    BodyComponent,
    SidenavComponent,
    SublevelMenuComponent,
    ShowDiagramComponent,
    UserNavComponent,
    FormComponent,
    DatatableHistorialComponent,
    LoginComponent,
    ModalNotifyComponent,
    LayoutComponent,
    OptionsDiagramComponent,
    UsuariosComponent,
    DataTableComponent,
    GrupoComponent,
    DatatableProcesosComponent,
    FormRedirectComponent,
    OtpEnlaceComponent,
    RolComponent,
    DatatableFormulariosComponent,
    FormEditComponent,
    IniciarProcesoComponent,
    TareasComponent,
    LogoutComponent,
    UsernavLogComponent,
    AccesoComponent,
    AuditoriaProcesosComponent,
    RenderFormComponent,
    SkeletonFormComponent,
    NotifyDataComponent,
    PermisosMenuComponent,
    TextBoxComponent,
    TextAreaComponent,
    ComboBoxComponent,
    CheckBoxComponent,
    HtmlEditorComponent,
    ButtonComponent,
    FormButtonsComponent,
    PreventOutsideClickDirective,
    DiagramViewerComponent,
    GenericModalComponent,
    DashboardComponent,
    ProcessDashboardComponent,
    PlantillasComponent,
    ConectoresComponent,
    TipoConectorComponent,
    SupersetReportComponent,
    DatatableBancoProcesosComponent,
    ReporteriaAdminComponent,
    ReporteriaVisorComponent
    //DateBoxComponent,
    
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    ModalModule.forRoot(),
    DataTablesModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatChipsModule,
    MatIconModule,
    MatAutocompleteModule,
    NgSelectModule,
    MatDatepickerModule,
    DateRangeBoxComponent,
    NgApexchartsModule,
    MsalModule.forRoot(
      MSALInstanceFactory(), 
      MSALGuardConfigFactory(),
      MSALInterceptorConfigFactory() 
    )
    //NgxExtendedPdfViewerModule
  ],
  providers: [
    MsalConfigApp,
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([customInterceptor])),
    {
      provide: APP_INITIALIZER,
      useFactory: AppProvider,
      multi: true
    },
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}

export function AppProvider(): () => Promise<any> {
  return (): Promise<any> => {
    return new Promise((resolve, reject) =>
    {
      // Función para verificar si ConfigData está disponible
      const checkConfigData = (attempts = 0): void => {
        if (typeof ConfigData !== 'undefined' && ConfigData) {
          console.log('ConfigData cargado correctamente');
          AppData.API_KEY = ConfigData.API_KEY;
          AppData.API_URL = ConfigData.API_URL;
          AppData.localStorageToken = ConfigData.localStorageToken;
          AppData.DIAGRAM_DATA = ConfigData.DIAGRAM_DATA;          
          AppData.tiempo_refresh_Tareas = ConfigData.tiempo_refresh_Tareas;          
          AppData.ALLOWED_FILE_TYPES = ConfigData.ALLOWED_FILE_TYPES;          
          AppData.MAX_FILE_SIZE = ConfigData.MAX_FILE_SIZE;          
          AppData.tiempo_refresh_Notificaciones= ConfigData.tiempo_refresh_Notificaciones;          
          AppData.MAX_LENGTH_FORM = ConfigData.MAX_LENGTH_FORM;
          AppData.ViewSSOLoginButton = ConfigData.ViewSSOLoginButton;
          AppData.ENABLE_CONECTORES = ConfigData.ENABLE_CONECTORES;
          AppData.ClientIdSSO = ConfigData.ClientIdSSO;
          AppData.AuthoritySSO = ConfigData.AuthoritySSO;
          AppData.ScopeSSO = ConfigData.ScopeSSO;
          AppData.RedirectUriSSO = ConfigData.RedirectUriSSO;
          AppData.ENABLE_AGENTE_REPETITIVAS = ConfigData.ENABLE_AGENTE_REPETITIVAS;
          AppData.CHUNKED_UPLOAD_THRESHOLD_MB = ConfigData.CHUNKED_UPLOAD_THRESHOLD_MB ?? 20;
          AppData.CHUNK_SIZE_MB = ConfigData.CHUNK_SIZE_MB ?? 5;
          AppData.ENABLE_CHUNKED_UPLOAD = ConfigData.ENABLE_CHUNKED_UPLOAD ?? true;
          AppData.ENABLE_AGENTE_CUELLOS_BOTELLA = ConfigData.ENABLE_AGENTE_CUELLOS_BOTELLA;
          AppData.MODO_VISUALIZACION_ANALISIS_IA = ConfigData.MODO_VISUALIZACION_ANALISIS_IA || 'notas';
          resolve(null);
        } else if (attempts < 20) {
          // Reintentar cada 100ms hasta 2 segundos
          setTimeout(() => checkConfigData(attempts + 1), 100);
        } else {
          console.error('ConfigData no se pudo cargar después de 2 segundos');
          reject(new Error('ConfigData no disponible'));
        }
      };

      checkConfigData();
    });
  };
}
